export function fmt(val, decimals = 1) {
  if (val == null) return '—';
  if (Math.abs(val) >= 1e6) return `$${(val / 1e6).toFixed(decimals)}M`;
  if (Math.abs(val) >= 1e3) return `$${(val / 1e3).toFixed(0)}K`;
  return `$${val.toFixed(0)}`;
}

export function fmtPct(val) {
  if (val == null) return '—';
  const sign = val >= 0 ? '+' : '';
  return `${sign}${val.toFixed(1)}%`;
}

export function calcDelta(ty, ly) {
  if (!ty || !ly) return null;
  return ((ty - ly) / ly) * 100;
}

export default function KPICard({ label, value, delta, deltaLabel, delta2, delta2Label, sublabel, accent }) {
  const isPos = delta >= 0;
  const isPos2 = delta2 >= 0;
  return (
    <div className="kpi-card" style={{ flex: 1, minWidth: 160 }}>
      <div style={{ fontSize: 11, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 6 }}>
        {label}
      </div>
      <div style={{ fontSize: 22, fontWeight: 700, color: accent || 'var(--text-primary)', marginBottom: 4 }}>
        {value}
      </div>
      {delta != null && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <span style={{ fontSize: 12, fontWeight: 600, color: isPos ? 'var(--success)' : 'var(--danger)' }}>
            {fmtPct(delta)}
          </span>
          {deltaLabel && <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>{deltaLabel}</span>}
        </div>
      )}
      {delta2 != null && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 2 }}>
          <span style={{ fontSize: 12, fontWeight: 600, color: isPos2 ? 'var(--success)' : 'var(--danger)' }}>
            {fmtPct(delta2)}
          </span>
          {delta2Label && <span style={{ fontSize: 11, color: 'var(--text-muted)' }}>{delta2Label}</span>}
        </div>
      )}
      {sublabel && <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>{sublabel}</div>}
    </div>
  );
}
